import React, { useState } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { useSelector } from "react-redux";
import line from "../../../assets/icons/line-stroke.svg";
import { FormatUSD } from "../../../utils/helpers/string";
import infoIcon from "../../../assets/icons/info.svg";
import { Tooltip } from "antd";

const GoalsBox = ({ item, newMaxLoss = [] }) => {
  const lastData = newMaxLoss && newMaxLoss.length > 0 ? newMaxLoss[newMaxLoss.length - 1] : null;
  console.log("item", item, lastData);

  const [show, setShow] = useState(false);

  const getStatusClass = (result) => {
    if (!result) return "danger status-box";
    const status = result.toLowerCase();
    return status === "passed"
      ? "pass status-box"
      : status === "in progress"
      ? "inProgress status-box"
      : "danger status-box";
  };

  const formatValue = (value, preText = "", postText = "") => {
    if (value === "N/A") return value;
    if (preText === FormatUSD) {
      return FormatUSD(value);
    }
    return `${preText}${value}${postText}`;
  };

  const renderProgressBar = () => {
    if (item.heading === "Maximum Loss Limit") {
      return (
        <div className="sliderMaxValue">
          Do not let your account drop below this equity level
        </div>
      );
    }

    let percentage = 0;
    const parsedPercentage = parseFloat(item.percentage);
    if (!isNaN(parsedPercentage)) {
      percentage = Math.max(0, parsedPercentage);
    } else {
      const minMaxNum = parseFloat(item?.minMax);
      const targetNum = parseFloat(item?.target);
      if (!isNaN(minMaxNum) && !isNaN(targetNum) && targetNum !== 0) {
        percentage = (Math.abs(minMaxNum) / Math.abs(targetNum)) * 100;
      }
    }
    return (
      <div className="sliderBase">
        <div
          style={{ width: `${percentage}%` }}
          className={`sliderActive ${
            item.result?.toLowerCase() === "passed"
              ? "Passed"
              : item.result?.toLowerCase() === "in progress"
              ? "in_Progress"
              : item.result?.toLowerCase() === "failed"
              ? "danger"
              : ""
          }`}
        >
          <div className="sliderCircle">
            <div className="sliderText">
              {formatValue(
                item.minMax === "N/A" ? 0 : item.minMax,
                item.preText,
                item.postText
              )}
            </div>
            <div className="sliderCircleInner" />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="goals-box">
      <div className="goals_container">
        <div className="goals-box-content">
          <h3
            className={`${
              item.heading.includes("Consistency Target")
                ? "consistency_heading"
                : ""
            }`}
          >
            {item.heading}{" "}
            {item.heading.includes("Consistency Target") && (
              <div style={{ position: "relative", display: "inline-block" }}>
                <Tooltip
                  title={
                    <div className="consistency_tooltip_box">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="upper_sec">
                          <p>
                            {FormatUSD(item?.best_day_pnl || 0)} (biggest day)
                          </p>
                          <hr
                            style={{
                              border: "none",
                              borderTop: "1px solid rgba(255,255,255,0.3)",
                              margin: "6px 0",
                            }}
                          />
                          <p>
                            {FormatUSD(item?.total_profit || 0)} (profit since
                            payout request)
                          </p>
                        </div>
                        <div>
                          <p> × 100 = {item?.percentage}% consistency</p>
                        </div>
                      </div>
                      <br />
                      <div className="consistency_tooltip_box_info">
                        <p>
                          Profit required to reach {item?.maximum_consistency}%
                          consistency:{" "}
                          <strong>
                            {lastData?.remaining_consistency_profit
                              ? FormatUSD(
                                  lastData?.remaining_consistency_profit
                                )
                              : "N/A"}
                          </strong>{" "}
                          Consistency resets when a payout is Requested.
                          <br />
                          <span>
                            If there is no profit overall your account will be
                            N/A.
                          </span>
                        </p>
                      </div>
                    </div>
                  }
                  placement="leftBottom"
                  overlayInnerStyle={{ width: 400, padding: 20 }}
                  color="#131313" // optional, for custom color
                >
                  <img
                    src={infoIcon}
                    alt="info"
                    style={{ marginLeft: "6px", cursor: "pointer" }}
                  />
                </Tooltip>
              </div>
            )}
          </h3>
          <p className="result">
            Result: {formatValue(item.minMax, item.preText, item.postText)}
            {item.RequiredProfit && newMaxLoss && (
              <p className="result margintop10px">
                <img src={line} alt="line" />
                Required Profit(Updated at EoD):{" "}
                {newMaxLoss[newMaxLoss.length - 1]?.remaining_consistency_profit
                  ? FormatUSD(
                      newMaxLoss[newMaxLoss.length - 1]
                        .remaining_consistency_profit
                    )
                  : "N/A"}
              </p>
            )}
          </p>
        </div>
        {!item.hideStatusIndicator && (
          <div className="goals-box-header">
            <div className={getStatusClass(item.result)}>
              <p>{item.result}</p>
            </div>
          </div>
        )}
      </div>
      <div className="slider-container">
        <div
          className="sliderMaxValue"
          style={{
            fontSize:
              item.heading === "Maximum Loss Limit" ? "20px" : undefined,
          }}
        >
          {formatValue(item.target, item.preText, item.postText)}
        </div>
        {renderProgressBar()}
      </div>
    </div>
  );
};

GoalsBox.propTypes = {
  item: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    result: PropTypes.string,
    minMax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    target: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    preText: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    postText: PropTypes.string,
    percentage: PropTypes.number,
    hideStatusIndicator: PropTypes.bool,
    RequiredProfit: PropTypes.string,
  }).isRequired,
  newMaxLoss: PropTypes.array,
};

function Goals({ data, newMaxLoss }) {
  const newData = data?.account_metrics?.program_objectives;
  // const accountData = useSelector((state) => state.accountList);
  // const isTrue = accountData?.data?.results?.find(
  //   (data) => Number(data.login_id) === Number(accountData?.login_id)
  // );

  const GoalsOverview = [
    // {
    //   heading: "Minimum Trading Days",
    //   result: newData?.trading_days_status || "N/A",
    //   minMax: newData?.trading_days || "N/A",
    //   target: newData?.trading_days_target || "N/A",
    //   preText: "",
    //   postText: "days",
    //   reverseLogic: true,
    // },
    {
      heading: "Profit",
      result: newData?.profit_status || "N/A",
      minMax: newData?.profit?.toFixed(2) || "N/A",
      target: newData?.profit_target?.toFixed(2) || "N/A",
      preText: FormatUSD,
      percentage: newData?.profit_progress_bar,
      postText: "",
    },
    {
      heading: "Maximum Loss Limit",
      result: newData?.max_loss_status || "N/A",
      minMax: newData?.max_loss?.toFixed(2) || "N/A",
      target: newData?.max_loss_target?.toFixed(2) || "N/A",
      maxLoss: newData?.remaining_max_loss?.toFixed(2) || "N/A",
      preText: FormatUSD,
      percentage: newData?.max_loss_progress_bar,
      postText: "",
    },
    {
      heading: "Daily loss",
      result: newData?.max_daily_loss_status || "N/A",
      minMax: newData?.max_daily_loss?.toFixed(2) || "N/A",
      target: newData?.max_daily_loss_target?.toFixed(2) || "N/A",
      percentage: newData?.daily_loss_progress_bar,
      preText: FormatUSD,
      postText: "",
      phase: data?.account_metrics?.calculated_data?.phase,
      plan_name: data?.account_metrics?.calculated_data?.plan_name,
    },
    {
      heading: `Best day cannot be greater than ${newData?.maximum_consistency}% of your total profits (Consistency Target)`,
      result:
        data?.account_metrics?.calculated_data?.consistency >
        newData?.maximum_consistency
          ? "failed"
          : "",
      minMax:
        data?.account_metrics?.calculated_data?.consistency > 0
          ? data?.account_metrics?.calculated_data?.consistency?.toFixed(2)
          : "N/A",
      target:
        data?.account_metrics?.calculated_data?.consistency >= 100
          ? data?.account_metrics?.calculated_data?.consistency.toFixed(2)
          : 100,
      preText: "",
      percentage: data?.account_metrics?.calculated_data?.consistency,
      postText: "%",
      RequiredProfit: "Dummy value",
      hideStatusIndicator: true,
      phase: data?.account_metrics?.calculated_data?.phase,
      plan_name: data?.account_metrics?.calculated_data?.plan_name,
      best_day_pnl: data?.account_metrics?.calculated_data?.best_day_pnl,
      total_profit: data?.account_metrics?.calculated_data?.total_profit,
      maximum_consistency: newData?.maximum_consistency,
    },
  ];
  const filteredGoals = GoalsOverview.filter((item) => {
    // Evaluation phase: keep Daily loss only for Zero Plan
    console.log("item.plan_name", item.plan_name);
    if (
      item.heading === "Daily loss" &&
      item.phase === "evaluation" &&
      (item.plan_name === "Advanced Plan" || item.plan_name === "Standard Plan")
    ) {
      if (item.plan_name === "Zero Plan") {
        return true;
      }
      return false;
    }
    // Qualified phase: always keep Daily loss for all plans
    // if (item.heading === "Daily loss" && item.phase === "qualified") {
    //   return true;
    // }
    if (item.phase === "qualified" && item.plan_name === "Advanced Plan")
      return false;
    if (
      item.phase === "evaluation" &&
      item.plan_name === "Zero Plan" &&
      item.RequiredProfit === "Dummy value"
    )
      return false;
    return true;
  });

  return (
    <div className="goals box">
      <h2 className="component-heading-goals">Trading Objective</h2>
      {/* <p className="text">
        You have successfully passed this phase of your evaluation! You will
        receive an e-mail with confirmation that your new account has been set
        up to continue to the next phase.
      </p> */}

      <div className="goals-box-wrapper">
        {filteredGoals.map((item, index) => (
          <GoalsBox key={index} item={item} newMaxLoss={newMaxLoss} />
        ))}
      </div>
    </div>
  );
}

Goals.propTypes = {
  data: PropTypes.shape({
    account_metrics: PropTypes.shape({
      program_objectives: PropTypes.object,
      calculated_data: PropTypes.object,
    }),
  }).isRequired,
  newMaxLoss: PropTypes.array,
};

export default Goals;
